import React from 'react';
import { uniq, compact } from 'lodash';
import {  CheckCircle, XCircle } from 'react-feather';
import classnames from 'classnames';

import { CourseComparisonComponentFragment } from '../../../../graphql.schema';

import * as styles from './StrapiCourseComparison.module.scss';

  export const StrapiCourseComparison = (
    {
    courseComparisonTable
  }: CourseComparisonComponentFragment
  ) => {
     if (!courseComparisonTable) return null;

     const courseNames = courseComparisonTable.courseName;
     const labels = uniq(compact(courseNames).flatMap((course) => course.coursesAvailable?.map((availableCourse) => availableCourse?.courseName)));
  
    const courseHeaderClass = classnames(styles.courseHeader);
 return (
  <div className={styles.root}>
    <table className={styles.table}>
      <thead>
        <tr>
          <th/>
          {compact(courseComparisonTable.courseName).map((item, index) => (
            <th
              key={`table-cefr-${courseComparisonTable.id}-${index}`}
              className={styles.tableHeader}
            >
              <span className={classnames('has-text-weight-bold')}>
                {item.name}
              </span>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {labels.map((label) => (
          <tr key={`tr-${label}`}>
            <td className={courseHeaderClass}>{label}</td>
            {compact(courseComparisonTable.courseName).map((item, index) => (
              <td
                key={`td-${label}-${index}`}
              >
                {item.coursesAvailable?.find((course) => course?.courseName === label)?.availability ? 
                <CheckCircle size={20} className="brand-a" data-testid={`check-circle-${index}`}/> : <XCircle size={20} className="black-3" data-testid={`times-circle-${index}`} />}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
};
